export class Clock {
  private last = performance.now();
  /** Returns seconds since last call, clamped to avoid spiral-of-death after tab-switch. */
  delta(): number {
    const now = performance.now();
    let dt = (now - this.last) / 1000;
    this.last = now;
    if (dt > 0.25) dt = 0.25;
    if (dt < 0) dt = 0;
    return dt;
  }
  reset(): void {
    this.last = performance.now();
  }
}
